import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import useStore from '../../hooks/useStore';
import useDropdown from '../DropDown';
import {interpolate, convertToNumber} from '../../lib/helpers';

import storyData from '../../data/story';
import rawData from '../../data/charts';

import {NavCustomLink} from './Navigation.styles';
import {Menu} from '../DropDown.styles';
import {withRouter} from 'react-router-dom';
import ChartsNavigation from './ChartsNavigation';

const TimelineNav = ({match}) => {
  const {state, dispatch} = useStore();
  const {activeChart, lang} = state;
  const years = storyData.map(({year}) => ({
    id: year,
    title: year,
  }));
  const activeYear = (match.params.year && Number(match.params.year)) || 1940;

  let data = useRef();

  // Prepare data once onMount
  useEffect(() => {
    data.current = rawData
      .map(function transformData({
        year,
        population,
        overAbstraction,
        waterPerCapita,
      }) {
        return {
          year: year,
          population: convertToNumber(population),
          overAbstraction: convertToNumber(overAbstraction),
          waterPerCapita: convertToNumber(waterPerCapita),
        };
      })
      .map(function interpolateData(obj, index, transformedData) {
        return obj.population > 0
          ? {...obj}
          : {
              ...obj,
              population: interpolate(obj.year, index, transformedData),
            };
      });
  }, []);

  const {
    activeItem,
    menuItems,
    setSelected,
    opened,
    ...layersDropDown
  } = useDropdown({
    active: activeYear,
    items: years,
    callback: (opened) =>
      dispatch({
        type: 'setActiveNav',
        payload: opened ? 'timeline-nav' : null,
      }),
  });

  function onClick(item) {
    setSelected(item);
    dispatch({
      type: 'setActiveNav',
      payload: null,
    });
  }

  return (
    <>
      <ChartsNavigation
        lang={lang}
        dispatch={dispatch}
        activeChart={activeChart}
      />
      {layersDropDown.renderToggleButton({
        label: activeItem ? `${activeItem.title}` : 'select',
      })}

      <Menu opened={opened}>
        {menuItems.map((item) => (
          <NavCustomLink
            onClick={() => onClick(item)}
            to={`/timeline/${item.title}`}
            key={item.id}
          >
            {item.title}
          </NavCustomLink>
        ))}
        <NavCustomLink
          onClick={() =>
            onClick({
              id: 'outro',
              title: '2020',
            })
          }
          to={`/outro`}
        >
          2020
        </NavCustomLink>
      </Menu>
    </>
  );
};

TimelineNav.propTypes = {
  match: PropTypes.object,
};
export default withRouter(TimelineNav);
